import React from 'react';
import { inject, observer } from 'mobx-react';
import { Tab, Tabs } from 'react-bootstrap';

// Components
import withLocalization from '~/hoc/withLocalization';
import TwoFactorSetup from './TwoFactorSetup';
import TwoFactorUsersList from './TwoFactorUsersList';

class SecuritySettings extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        const { authStore } = this.props;
        authStore.reset();
    }

    render() {
        const { t, userStore } = this.props;

        return (
            <div>
                <div className='fw-600 custom-customer-header text-capitalize mb-3'>{t('Security Settings')}</div>
                {
                    userStore.currentUser?.user_type === 'admin' ?
                        <div className="control-panel">
                            <Tabs defaultActiveKey="admin" id="SecurityTabContainer">
                                <Tab eventKey="admin" title={t('Admin')}>
                                    <TwoFactorSetup source={'settings'} />
                                </Tab>
                                <Tab eventKey="users" title={t('Users')}>
                                    <TwoFactorUsersList />
                                </Tab>
                            </Tabs>
                        </div>
                        :
                        <div className="control-panel">
                            <TwoFactorSetup source={'settings'} />
                        </div>
                }
            </div>
        );
    }
}

export default inject('authStore', 'userStore')(withLocalization(observer(SecuritySettings)));
